import classNames from 'classnames'
import React from 'react'

export interface HeaderTitleProps {
  children: React.ReactNode
  className?: string
}

const HeaderTitle: React.FC<HeaderTitleProps> = (props) => {
  const { children, className } = props
  return (
    <h1
      className={classNames(
        'font-medium text-4xl text-common-gray-7 phone:text-2xl phone:text-common-gray-7 phone:px-4',
        className
      )}
    >
      {children}
    </h1>
  )
}

export default HeaderTitle
